import { Box, Container } from '@mui/material';
import CustomRouter from './Routes';
import Footer from './layouts/Footer';

function App() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      <Container>
        <CustomRouter />
      </Container>
      <Footer />
    </Box>
  );
}

export default App;